import script from "./AdminUserForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminUserForm.vue?vue&type=script&setup=true&lang=ts"

import "./AdminUserForm.vue?vue&type=style&index=0&id=c85e1ec0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c85e1ec0"]])

export default __exports__